import React, { useState } from 'react';

import SideMenu from './SideMenu';
import { AddAPetModal } from '../myPets/AddAPetModal';

import menuIcon from '../../assets/sideMenu/burger-menu.svg';

import { useContactUsToggler } from '../../hooks';

export const SideAndBurgerMenu = ({
  modalAddPetVisible = false,
  toggleModalAddPetVisible = () => { },
}) => {
  const [leftMenuOpen, setLeftMenuOpen] = useState(false);
  const { onContactUsToggle } = useContactUsToggler();

  const toggleSidebar = () => {
    setLeftMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    if (leftMenuOpen) {
      setLeftMenuOpen(false);
    }
  };

  return (
    <>
      <div id="left">
        <button
          className={'Side-menu-burger-icon'
                + `${leftMenuOpen ? ' Side-menu-burger-open' : ''}`}
          onClick={toggleSidebar}
          type="button"
        >
          <img
            alt=""
            src={menuIcon}
          />
        </button>

        <div className={`sidebar ${leftMenuOpen ? 'open' : 'closed'} Sidebar`}>
          <div className="content">
            <SideMenu
              onMenuItemPress={closeMenu}
              setContactUsVisible={onContactUsToggle}
              toggleModalAddPetVisible={toggleModalAddPetVisible}
            />
          </div>
        </div>
      </div>

      <AddAPetModal
        modalAddPetVisible={modalAddPetVisible}
        onCloseModalAddPet={toggleModalAddPetVisible}
      />

      {leftMenuOpen && (
        <button
          className="Sidebar-overlay"
          onClick={toggleSidebar}
          type="button"
        />
      )}
    </>
  );
};
